<mat-tab-group animationDuration="400ms" (selectedIndexChange)="onTabChange($event)">
  <mat-tab label="Minhas Ordens de Serviço">
    <supplier-portal-os-list />
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <span>Solicitações de Cotação</span>
      @if (pendingCount > 0) {
        <span
          class="ml-2 inline-flex items-center justify-center rounded-full bg-red-500 text-white text-xs font-bold min-w-5 h-5 px-1.5"
          [matTooltip]="
            pendingCount === 1
              ? '1 solicitação aguardando sua cotação'
              : pendingCount + ' solicitações aguardando sua cotação'
          "
        >
          {{ pendingCount }}
        </span>
      }
    </ng-template>
    @if (quoteTabLoaded) {
      <supplier-portal-quote-list (respostaEnviada)="loadPendingCount()" />
    }
  </mat-tab>
</mat-tab-group>
